import { useAutoneTranslation } from '@autone/translations';
import {
  TailwindCard,
  TailwindCardContent,
  useTrackModuleViews,
} from '@autone/ui';
import { Button } from '@autone/ui-next/atoms';
import { ArrowLeftIcon } from '@autone/ui-next/icons';
import { createFileRoute } from '@tanstack/react-router';
import { useNavigate } from '@tanstack/react-router';
import { useAtom } from 'jotai';

import { AssortmentDataFeedTooltip } from '../../../../new/features/data-feed/AssortmentDataFeedTooltip';
import { APP_NAME } from '../../../../old/consts';
import { ProductLocationsTable } from '../../../../old/features';
import { AssortmentDocsLink } from '../../../../old/features/assortment-docs-link';
import { AssortmentExtrasMenu } from '../../../../old/features/assortment-extras-menu';
import { AssortmentFilterChips } from '../../../../old/features/assortment-filters';
import AssortmentFilterButton from '../../../../old/features/assortment-filters/AssortmentFilterButton';
import AssortmentSearchInput from '../../../../old/features/assortment-filters/AssortmentSearchInput';
import {
  ProductGroupBadges,
  ProductLocationsHeaderTitle,
} from '../../../../old/features/product-locations-header';
import {
  AssortedLocationsKPICard,
  AvailableInventoryKPICard,
  SaleDatesKPICard,
  TotalSalesKPICard,
} from '../../../../old/features/product-locations-kpi-cards';
import { AssortmentLayout } from '../../../../old/layout';
import { productLocationsSearchTermAtom } from '../../../../old/storage/atoms';

const ProductLocationsView = () => {
  useTrackModuleViews({
    app: APP_NAME,
    view: 'product view',
    viewMode: 'main',
  });
  const navigate = useNavigate();
  const { t } = useAutoneTranslation<typeof APP_NAME>();
  const [searchTerm, setSearchTerm] = useAtom(productLocationsSearchTermAtom);

  return (
    <>
      <AssortmentLayout
        leftExtras={
          <Button
            variant="ghost"
            id="go-to-in-season-page"
            aria-label={t('pages.in-season.sub-header')}
            size="icon"
            onClick={() => navigate({ to: '/in-season' })}
          >
            <ArrowLeftIcon />
          </Button>
        }
        headerText={t('pages.in-season.header')}
        subHeaderText={
          <div className="flex gap-1">
            <p>{t('pages.in-season.sub-header')}</p>
            {'·'}
            <AssortmentDocsLink />
          </div>
        }
        subHeaderExtras={<AssortmentDataFeedTooltip />}
      >
        <TailwindCard>
          <TailwindCardContent className="flex flex-col gap-6 items-start p-6">
            <div className="flex items-center w-full">
              <div className="space-y-3">
                <ProductLocationsHeaderTitle />
                <ProductGroupBadges />
              </div>

              <div className="flex items-center ml-auto gap-2 h-full">
                <AssortmentSearchInput
                  value={searchTerm}
                  onChange={(value) => setSearchTerm(value)}
                />
                <AssortmentFilterButton
                  align="end"
                  tableName="productLocationsTable"
                />
                <AssortmentExtrasMenu
                  tableName={'productLocationsTable'}
                  align={'end'}
                />
              </div>
            </div>
            <AssortmentFilterChips tableName="productLocationsTable" />
          </TailwindCardContent>
        </TailwindCard>
        <div className="flex flex-row gap-2 h-[160px]">
          <AssortedLocationsKPICard />
          <SaleDatesKPICard />
          <TotalSalesKPICard />
          <AvailableInventoryKPICard />
        </div>
        <ProductLocationsTable searchTerm={searchTerm} />
      </AssortmentLayout>
    </>
  );
};

export const Route = createFileRoute('/(old)/product/$productId/locations')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ProductLocationsView />;
}
